
export const siteSettings = {
    name: "عنب وكوكيز",
    shortName: "عنب وكوكيز",
    description: "عنب وكوكيز | Grapes And Cookies",
    themeColor: {
        light: "#ffffff",
        dark: "#374151"
    },
    backgroundColor: "#ffffff",
    display: "standalone",
    scope: "/",
    startUrl: "/",
    categories: ["food", "restaurant"],
    orientation: "portrait",
    language: "ar",
    direction: "rtl"
};

// إعدادات التثبيت
export const installSettings = {
    enabled: false, // تفعيل أو تعطيل نافذة التثبيت
    title: "تثبيت عنب وكوكيز",
    description: "قم بتثبيت عنب وكوكيز للوصول السريع والاستخدام بدون إنترنت",
    safari: {
        title: "اتبع الخطوات التالية : ",
        steps: [
            "اضغط على زر المشاركة",
            "اختر إضافة إلى الصفحة الرئيسية",
            <>اضغط على <span className="font-bold text-[#007AFF]">إضافة</span></>
        ]
    },
    chrome: {
        title: "تثبيت التطبيق على جهازك",
        description: "قم بتثبيت التطبيق للوصول السريع والاستخدام بدون إنترنت"
    },
    buttons: {
        install: "تثبيت",
        later: "لاحقاً",
        understood: "فهمت"
    }
};
